import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1a83a65d")
const _hoisted_1 = {
  key: 0,
  class: "landing-page page"
}
const _hoisted_2 = { class: "landing-page-inner" }
const _hoisted_3 = { class: "icon-container" }
const _hoisted_4 = { class: "language-switch" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" | ")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Footer = _resolveComponent("Footer")!

  return ($setup.cmsData != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", null, _toDisplayString($setup.cmsData.Title), 1),
          _createElementVNode("h2", null, _toDisplayString($setup.cmsData.Introduction), 1),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.$store.state.sceneReady)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  onClick: $setup.AddBlending,
                  class: "cta-link",
                  to: '/' + $setup.getLang() + '/content'
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString($setup.cmsData.CallToAction), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "to"]))
              : _createCommentVNode("", true),
            (!_ctx.$store.state.sceneReady)
              ? (_openBlock(), _createBlock(_component_Loading, {
                  key: 1,
                  class: "neurocure-loading-icon"
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: _normalizeClass(["cta-button lang", { active: $setup.getLang() == 'de' }]),
              onClick: _cache[0] || (_cache[0] = (e) => $setup.setLang('de'))
            }, " DE ", 2),
            _hoisted_5,
            _createElementVNode("button", {
              class: _normalizeClass([{ active: $setup.getLang() == 'en' }, "cta-button lang"]),
              onClick: _cache[1] || (_cache[1] = (e) => $setup.setLang('en'))
            }, " ENG ", 2)
          ])
        ]),
        _createVNode(_component_Footer, { showLang: false })
      ]))
    : _createCommentVNode("", true)
}